import React from "react";
import PropTypes from "prop-types";
import GrantScheduleTable from "../GrantScheduleTable/GrantScheduleTable";
import { CustomModal, ModalHeading } from "../../style";
import { ButtonContainer } from "../GrantPopup/style";
import { GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";

const renderFooter = (closeToggle) => (
  <ButtonContainer>
    <GeneralButton
      text="Close"
      key="Close"
      onClick={closeToggle}
      type="functional"
      width='100%'
      mobWidth='100%'
      inverted
    />
  </ButtonContainer>
);

function ScheduleRecurringPopup({
  grantName,
  amount,
  frequency,
  startDate,
  noOfPayment,
  closeToggle
}) {
  return (
    <div>
      <CustomModal
        title={[<ModalHeading>Recurring grant schedule</ModalHeading>]}
        visible
        onCancel={closeToggle}
        footer={renderFooter(closeToggle)}
        width="595px"
        padding="0"
        maxHeight
      >
        <GrantScheduleTable
          scroll={{ y: 300 }}
          grantName={grantName}
          amount={amount}
          frequency={frequency}
          startDate={startDate}
          noOfPayments={noOfPayment}
          dateLabel="Scheduled Date"
        />
      </CustomModal>
    </div>
  );
}

ScheduleRecurringPopup.propTypes = {
  grantName: PropTypes.string,
  amount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  frequency: PropTypes.string,
  startDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  noOfPayment: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  closeToggle: PropTypes.func
}

export default ScheduleRecurringPopup;
